import React from 'react';
import { Routes, Route, useLocation } from "react-router-dom";
import Header from './components/Header';
import Footer from './components/Footer';

// Páginas
import Home from './pages/Home';
import QuemSomos from './pages/QuemSomos';
import Produtos from './pages/Produtos';
import Blog from './pages/Blog';

// import ProtecaoInteligente from './pages/ProtecaoInteligente';
// import EnergiaFotovoltaica from './pages/EnergiaFotovoltaica';
// import ProjetosEletricos from './pages/ProjetosEletricos';
// import AirCondicionado from './pages/AirCondicionado';
// import CasaInteligente from './pages/CasaInteligente';
// import Contato from './pages/Contato';

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function BackToTop() {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 420);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      className="back-to-top"
      type="button"
      aria-label="Voltar ao topo"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <span aria-hidden="true">↑</span>
    </button>
  );
}

function App() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  return (
    <div className="App">
      <ScrollToTop />
      <Header />
      {/* Fora da Home, compensa a altura do header fixo */}
      <main className={isHome ? "no-offset" : "pt-header"}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/quem-somos" element={<QuemSomos />} />
            <Route path="/produtos" element={<Produtos />} />
            <Route path="/blog/:slug" element={<Blog />} />
            {/*<Route path="/energia-fotovoltaica" element={<EnergiaFotovoltaica />} />*/}
            {/*<Route path="/projetos-eletricos" element={<ProjetosEletricos />} />*/}
            {/*<Route path="/ar-condicionado" element={<AirCondicionado />} />*/}
            {/*<Route path="/casa-inteligente" element={<CasaInteligente />} />*/}
            {/*<Route path="/contato" element={<Contato />} />*/}
        </Routes>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}

export default App;
